import React from "react";
import { Navigate, useParams } from "react-router-dom";
import { buildDataConnectorDetailPath } from "../../../services/kg/dataSourcesMappers";

/** Sends an old screen about one connection to that connector's v2 page, where its tables are. */
const ToConnectorPage: React.FC = () => {
  const { connectionId = "" } = useParams<{ connectionId: string }>();
  return <Navigate to={buildDataConnectorDetailPath(connectionId)} replace />;
};

export default ToConnectorPage;
